import React, { useState } from 'react';
import { useNotificationProvider } from '../../services/notification';
import { nextId } from '../../services/identityGenerator';

import Notification from './Notification';

import styles from './Notification.module.css';

export const NotificationProvider = (props) => {
    const [notifications, setNotifications] = useState([]);
    const NotificationProvider = useNotificationProvider();

    const removeNotification = id => {
        setNotifications(prev => {
            const index = prev.findIndex(n => n.id === id);
            clearInterval(prev[index]);
            return [...prev.slice(0, index), ...prev.slice(index + 1)]
        });
    }

    const pushNotification = options => {
        const id = nextId();
        const notification = {
            id: id,
            title: options.title,
            message: options.message,
            duration: options.duration,
            type: options.type || "default",
            startTime: (new Date()).getTime(),
            timer: setTimeout(() => removeNotification(id), options.duration || 5000),
            paused: false
        };

        setNotifications(prev => options.top ?
            [notification, ...prev]
            : [...prev, notification]);
    }

    const success = (message, duration) => pushNotification({ type: "success", message, duration });
    const warning = (message, duration) => pushNotification({ type: "warning", message, duration });
    const info = (message, duration) => pushNotification({ type: "info", message, duration });
    const error = (message, duration) => pushNotification({ type: "danger", message, duration });

    const updateNotification = (id, updates) => {
        setNotifications(prev => {
            const index = prev.findIndex(n => n.id === id);
            const notification = prev[index];
            const next = [
                ...prev.slice(0, index),
                { ...notification, ...updates(notification) },
                ...prev.slice(index + 1)
            ];
            
            return next;
        });
    }

    const pauseTimer = id => {
        updateNotification(
            id,
            prev => {
                if (prev.paused)
                    return;

                clearTimeout(prev.timer);

                return {
                    remaining: (new Date()).getTime() - prev.startTime,
                    paused: true
                }
            }
        );
    }

    const resumeTimer = id => {
        updateNotification(
            id,
            prev => {
                if (!prev.paused)
                    return;

                return {
                    startTime: (new Date()).getTime(),
                    paused: false,
                    timer: setTimeout(() => removeNotification(prev.id), prev.remaining)
                }
            }
        )
    }

    const notificationAPI = {
        dispatch: pushNotification,
        success,
        warning,
        info,
        error,
        dismiss: removeNotification
    }

    return (
        <NotificationProvider value={notificationAPI}>
            {props.children}
            <div className={styles.container}>
                {notifications.map(n => <Notification
                    key={n.id}
                    type={n.type}
                    message={n.message}
                    onResumeTimer={() => resumeTimer(n.id)}
                    onPauseTimer={() => pauseTimer(n.id)}
                    click={() => removeNotification(n.id)}
                />)}
            </div>
        </NotificationProvider>
    );
}